import {
    forEach as _forEach,
    extend as _extend,
    indexOf as _indexOf
} from "lodash-es";

import formTemplateSource from "./template/domain.html";

let formCounter = 0;
export default class ModalForm {
    /**
     *
     * @param element {jQuery}
     * @param props {Object}
     */
    constructor(element, props = {}) {
        this.element = element;
        this.props = {
            domainName: window.location.hostname,

            title: null,
            offerPlaceholder: "", // data-placeholder

            minOfferAmount: 0, //data-min-offer-amount
            formId: "1",
            link: "",
            templateId: "",
            templateSource: "special_template",
        };
        _extend(this.props, props);
        if (!this.props.id) {
            formCounter++;
            this.props.id = "domainContactForm" + formCounter;
        }
        this.update = this.update.bind(this);
        this.updateLink = this.updateLink.bind(this);
        this.prepareTemplate = this.prepareTemplate.bind(this);
    }

    update() {
        this.prepareTemplate();
        this.updateLink();
    }

    prepareTemplate() {
        let formTemplate = $(formTemplateSource);
        let titleElement = formTemplate.find("#formModalLabel");

        let iframe = formTemplate.find("iframe");

        let formName;
        // debugger;
        switch (this.props.formId) {
            case 1:
            case '1':
                formName = 'form.html';
                titleElement.text("Contact us");
                iframe.height(390);
                break;
            case 2:
            case '2':
                formName = 'form2.html';
                titleElement.text("Offer for " + this.props.domainName);
                iframe.height(460);
                break;
            case 3:
            case '3':
            case 'escrow':
                formName = 'escrow.html';
                titleElement.text("Offer for " + this.props.domainName + " through Escrow.com");
                iframe.height(260);
                break;
            case 'link':
                return;
        }

        iframe.attr('src', process.env.formOrigin + '/' + formName + "?" + jQuery.param({
            id: this.props.id,
            title: this.props.title,
            minOfferAmount: this.props.minOfferAmount,
            domainName: this.props.domainName,
            userId: this.props.userId,
            offerPlaceholder: this.props.offerPlaceholder,
            template_id: this.props.templateId,
            template_source: this.props.templateSource,
        }));
        _forEach(this.props, (value, parameter) => {
            switch (parameter) {
                case 'id':
                    formTemplate.attr(parameter, value);
                    break;
            }
        });


        formTemplate.appendTo(document.body);
        let target_iframe = document.querySelector("#" + this.props.id + " iframe");

        target_iframe.onload = function () {

            let theme_color = $(".modal-header").css("background-color");

            target_iframe.contentWindow.postMessage({
                test: "TEST MESSAGE",
                theme_color: theme_color
            }, "*");
        };
    }

    updateLink() {
        if (this.props.formId == 'link') {
            this.element.on("click", (event) => {
                event.preventDefault();
                window.open(this.props.link, '_contact');
            });
        } else {
            this.element.attr("data-toggle", "modal");
            this.element.attr("data-target", "#".concat(this.props.id));
        }
    }

    static autoDetect() {
        let allLinks = $('*[data-WCPModal="domain"]');
        _forEach(allLinks, (linkElement, i) => {
            let linkElementJQuery = $(linkElement);
            let props = {};
            // debugger;
            _forEach(linkElementJQuery.data(), (value, propName) => {
                if (_indexOf(ModalForm.knownProps(), propName) !== false) {
                    props[propName] = value;
                }
            });
            let modalForm = new ModalForm(linkElementJQuery, props);
            modalForm.update();
        });
    }

    static knownProps() {
        return [
            'id',
            'domainName',

            'title',
            'offerPlaceholder',
            'userId',
            'minOfferAmount',
            'formId',
            'link',
            'templateId',
            'templateSource'
        ];
    }
}


//
// window.addEventListener("message", receiveMessage, false);
//
// function receiveMessage(event) {
//     let origin = event.origin || event.originalEvent.origin; // For Chrome, the origin property is in the event.originalEvent object.
//
//     if (origin !== process.env.formOrigin) {
//         return;
//     }
//     console.log(event.data);
//     if( event.data.type == 'fixSize') {
//         $('#' + event.data.popupId + ' #iframe').height( event.data.height);
//     } else {
//         let popup = $("#"+event.data);
//         let frame = popup.find("iframe");
//         setTimeout(function () {
//             frame[0].src += '';
//             popup.modal('hide');
//         },3000);
//     }
//
//     // ...
// }
//
//


window.WCPModal = ModalForm;


/** WEBPACK FOOTER **
 ** ./src/main.js
 **/